module.exports = __webpack_public_path__ + "img/007-jupiter.33b8e4a3.svg";